import { forwardRef } from "react";
import React, { useRef, useEffect, useState } from "react";
import CertificateCard from "./CertificateCard";
import app from "../firebase/firebase";
import { getDatabase, ref, onValue } from "firebase/database";
import icon from "../assets/laptop.jpg";
import Loading from "./Loading";

const Certificates = forwardRef(function Certificates(props, refCertificates) {
  const containerRef = useRef(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    // Initialize Realtime Database and get a reference to the service
    const db = getDatabase(app);
    const project = ref(db, "certificates/");

    onValue(project, (snapshot) => {
      const fetchedData = snapshot.val();
      setData(fetchedData); // Update the state with fetched data
    });
  }, []); // Empty dependency array ensures this effect runs only once on component mount

  return (
    <div
      className="page flex flex-col items-center justify-center min-h-screen px-4 md:px-12 py-10"
    >
      <div className="w-full flex flex-col items-center">
        <h1
          className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-[#00df9a] to-emerald-400 drop-shadow-lg mb-8 md:mb-12 text-center"
          ref={refCertificates}
        >
          Certificates
        </h1>
        <div className="flex overflow-x-auto w-full max-w-7xl pb-8 custom-scrollbar gap-6 items-stretch snap-x snap-mandatory">
          {data === null ? (
            <div className="w-full flex justify-center py-20">
              <Loading />
            </div>
          ) : (
            data.map((project, index) => (
              <div key={index} className="snap-center shrink-0 w-[85vw] md:w-[500px]">
                <CertificateCard
                  title={project.title}
                  imgSrc={project.certificate_path}
                />
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
});

export default Certificates;
